/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetCustomerVaultResponse
 */
export interface GetCustomerVaultResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetCustomerVaultResponse
     */
    id: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetCustomerVaultResponse
     */
    userId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetCustomerVaultResponse
     */
    customerId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerVaultResponse
     */
    type: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerVaultResponse
     */
    accountType: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerVaultResponse
     */
    lastFour: string | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetCustomerVaultResponse
     */
    cardExpMonth: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetCustomerVaultResponse
     */
    cardExpYear: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomerVaultResponse
     */
    isDefault: boolean;
    /**
     * 
     * @type {Date}
     * @memberof GetCustomerVaultResponse
     */
    createdAt: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerVaultResponse
     */
    bankName: string | null;
}

/**
 * Check if a given object implements the GetCustomerVaultResponse interface.
 */
export function instanceOfGetCustomerVaultResponse(value: object): value is GetCustomerVaultResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('accountType' in value) || value['accountType'] === undefined) return false;
    if (!('lastFour' in value) || value['lastFour'] === undefined) return false;
    if (!('cardExpMonth' in value) || value['cardExpMonth'] === undefined) return false;
    if (!('cardExpYear' in value) || value['cardExpYear'] === undefined) return false;
    if (!('isDefault' in value) || value['isDefault'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('bankName' in value) || value['bankName'] === undefined) return false;
    return true;
}

export function GetCustomerVaultResponseFromJSON(json: any): GetCustomerVaultResponse {
    return GetCustomerVaultResponseFromJSONTyped(json, false);
}

export function GetCustomerVaultResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCustomerVaultResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetPageParameterFromJSON(json['id']),
        'userId': ApiUserTasksGetPageParameterFromJSON(json['userId']),
        'customerId': ActorActivityRecordActorUserIdFromJSON(json['customerId']),
        'type': json['type'],
        'accountType': json['accountType'],
        'lastFour': json['lastFour'],
        'cardExpMonth': ActorActivityRecordActorUserIdFromJSON(json['cardExpMonth']),
        'cardExpYear': ActorActivityRecordActorUserIdFromJSON(json['cardExpYear']),
        'isDefault': json['isDefault'],
        'createdAt': (json['createdAt'] == null ? null : new Date(json['createdAt'])),
        'bankName': json['bankName'],
    };
}

export function GetCustomerVaultResponseToJSON(json: any): GetCustomerVaultResponse {
    return GetCustomerVaultResponseToJSONTyped(json, false);
}

export function GetCustomerVaultResponseToJSONTyped(value?: GetCustomerVaultResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetPageParameterToJSON(value['id']),
        'userId': ApiUserTasksGetPageParameterToJSON(value['userId']),
        'customerId': ActorActivityRecordActorUserIdToJSON(value['customerId']),
        'type': value['type'],
        'accountType': value['accountType'],
        'lastFour': value['lastFour'],
        'cardExpMonth': ActorActivityRecordActorUserIdToJSON(value['cardExpMonth']),
        'cardExpYear': ActorActivityRecordActorUserIdToJSON(value['cardExpYear']),
        'isDefault': value['isDefault'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'bankName': value['bankName'],
    };
}

